<template>
  <el-drawer :wrapperClosable="false"
             :visible.sync="dialogVisble"
             size="50%" :show-close="false" destroy-on-close>
    <template #title>
      <div style="height: 50px">
        <div class="staff_head">
          <div class="staff_l">
            <img src="@/assets/structure/close.png" class="staff_close" @click="handleClose" />
            <div>访客邀约</div>
          </div>
          <div style="text-align: right;">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
          </div>
        </div>
      </div>
    </template>
    <div style="padding:0 20px;">
      <el-form :model="form" :rules="rules" ref="formRef">
        <el-card header="基础信息" class="visitor-type-card">
          <template #header>
            <div style="display: flex;align-items: center;">
              <svg t="1772008479269" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5924" width="12" height="12"><path d="M793.344 460.8l2.986667 2.030933c18.039467 14.0288 39.850667 38.877867 60.194133 49.169067 26.658133 13.482667 51.950933 28.7232 81.2032 35.601067 15.172267 3.584 30.429867 6.485333 45.9776 7.68l10.717867 0.682666 29.576533 1.348267-0.034133 227.703467c0 5.6832-0.2048 11.383467-0.836267 17.032533-2.1504 19.319467-7.953067 37.614933-16.145067 55.210667-11.741867 25.1904-27.4432 47.786667-45.994666 68.471466-31.3344 34.952533-67.498667 63.709867-110.455467 83.5584a161.058133 161.058133 0 0 1-39.3728 12.8c-4.3008 0.785067-8.6528 1.28-12.970667 1.911467h-9.147733l-10.069333-1.399467c-18.107733-2.901333-34.986667-9.3696-51.2512-17.5616-31.812267-16.008533-59.904-37.1712-85.128534-62.0544-23.995733-23.637333-44.544-49.834667-59.562666-80.0256-12.2368-24.490667-19.8656-50.1248-19.831467-77.755733l0.0512-112.384v-115.131733l0.733867-0.3584 1.194666-0.119467 1.194667-0.068267c20.992-0.324267 41.8304-1.706667 62.5152-5.546666 15.9232-2.9696 46.762667-14.062933 70.314667-26.282667 24.7808-12.868267 84.002133-56.337067 94.139733-64.512z m-1.4848 69.307733c-20.309333 12.731733-51.2 28.330667-85.7088 44.9024l-6.946133 3.328c-9.608533 4.573867-74.496 28.2112-84.992 29.9008l-0.682667 122.538667c-0.1536 52.411733 0.068267 80.110933 0.682667 83.0976l2.389333 11.639467c2.218667 9.728 3.8912 12.014933 12.9536 25.6 23.773867 35.584 54.272 64.5632 89.5488 88.712533 16.315733 11.195733 33.467733 20.872533 52.4288 27.067733 10.154667 3.310933 20.445867 5.000533 31.163733 2.9696 14.404267-2.730667 27.630933-8.482133 40.379734-15.36 27.511467-14.848 51.9168-33.792 74.018133-55.688533 20.667733-20.4288 38.673067-42.888533 51.797333-68.9152 9.454933-18.807467 3.362133-23.3984 3.345067-44.6976l0.187733-104.413867 0.341334-72.5504c-9.045333-1.365333-62.6688-20.8384-85.504-29.9008-32-12.6976-62.6688-30.0032-91.784534-48.2304-1.365333-0.853333-2.304-0.8192-3.618133 0zM221.7472 17.066667v68.266666H119.466667c-19.387733 0-32.8704 12.253867-34.048 32.119467L85.333333 120.354133v698.9312c0 20.5824 12.509867 33.024 31.402667 33.9968L119.466667 853.333333h238.933333c22.545067 5.051733 33.826133 16.520533 33.826133 34.4064 0 16.878933-10.069333 27.886933-30.173866 33.024L358.4 921.6H110.421333c-50.039467 0-91.3408-41.1136-93.2864-92.945067L17.066667 824.832V110.933333c0-52.309333 40.0896-91.886933 90.112-93.7984L110.933333 17.066667h110.813867z m667.118933 648.533333L921.6 697.002667 777.216 870.4 682.666667 786.756267l29.115733-35.754667 60.893867 53.2992 115.2512-137.642667 0.938666-1.058133z m-462.148266-51.2c17.015467 0 33.6896 16.725333 33.6896 34.116267 0 16.571733-15.189333 32.631467-31.368534 34.048l-2.321066 0.1024H204.407467C187.8528 682.666667 170.666667 665.429333 170.666667 648.516267c0-16.759467 15.394133-32.597333 31.4368-34.013867l2.304-0.1024h222.3104zM512 426.666667c16.657067 0 34.133333 17.288533 34.133333 34.133333 0 16.0768-15.837867 32.5632-31.8464 34.030933L512 494.933333H205.226667C187.5968 494.933333 170.666667 477.559467 170.666667 460.782933c0-16.315733 15.6672-32.5632 32.2048-34.013866l2.3552-0.1024H512zM776.533333 17.066667c34.167467 0 91.1872 41.250133 93.781334 92.672l0.085333 3.754666V358.4c-4.164267 22.9376-15.394133 34.423467-33.672533 34.423467-17.3056 0-28.5696-10.308267-33.792-30.890667L802.133333 358.4V119.466667c0-20.036267-11.127467-32.9216-31.197866-34.048L768 85.333333h-102.4V17.066667h110.933333zM682.666667 238.933333c17.066667 0 34.167467 16.2816 34.167466 34.133334 0 17.0496-15.735467 32.648533-31.863466 34.030933L682.666667 307.2H204.970667c-16.964267 0-34.304-17.117867-34.304-36.590933 0-14.626133 15.138133-30.122667 31.7952-31.573334L204.970667 238.933333H682.666667zM527.4624 0C547.4304 0 563.2 18.602667 563.2 40.925867v20.599466C563.2 84.394667 546.952533 102.4 527.4624 102.4h-167.458133C340.292267 102.4 324.3008 84.104533 324.266667 61.525333V40.925867C324.266667 18.056533 340.514133 0 360.004267 0h167.458133z" fill="#1296db" p-id="5925"></path></svg>
              <span style="margin-left: 6px;">基础信息</span>
            </div>
          </template>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="访客姓名" prop="visitor">
                <el-input v-model="form.visitor" placeholder="请输入访客姓名"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访客手机号" prop="phoneNum">
                <el-input v-model="form.phoneNum" placeholder="请输入访客手机号"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="随行人数" prop="personCnt">
                <el-input-number :min="1" v-model="form.personCnt" style="width: 100%;" placement="请输入随行人数"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访客类型" prop="visitorTypeId">
                <el-select v-model="form.visitorTypeId"
                           @change="handleChangeVisitorType"
                           placeholder="请选择访客类型" style="width: 100%;margin-left: 0px;">
                  <el-option
                      v-for="item in visitorTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="通行设备" prop="deviceList">
                <div style="width: 100%;display: flex;color:gray;">
                  <div class="access" @click="handleDeviceClick">
                    <div  class="placeholder" v-if="!form?.deviceList || form?.deviceList?.length==0"> 请选择通行设备 </div>
                    <div class="wrap" v-else>
                      <div class="wrap_item">{{ form?.deviceList?.length>0?form?.deviceList[0]?.name:'' }}</div>
                      <div class="wrap_item" v-if="form?.deviceList?.length>1">+{{ form?.deviceList?.length-1 }}</div>
                    </div>
                    <i class="el-icon-circle-plus-outline" style="font-size: 14px;"></i>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="访问时间" prop="visitDateTime">
                <el-date-picker
                    v-model="form.visitDateTime"
                    type="datetimerange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    style="width: 100%"
                    @change="handleChangeVisitDateTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="更多信息" class="visitor-type-card" style="margin-top: 20px;">
          <template #header>
            <div style="display: flex;align-items: center;">
              <svg t="1772008932784" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8461" width="15" height="15"><path d="M635.83847 535.057135c-15.866363 0-29.007661 6.321986-39.419801 18.965957-10.413164 12.644995-15.618723 27.395954-15.618723 44.254923l0 90.739631L490.802212 860.084767l-63.963801-237.263775-262.551718-82.558297 693.194782-376.348484L661.870356 535.057135 635.83847 535.057135 635.83847 535.057135zM830.705646 579.683519c7.933693 0 14.751982 2.850931 20.453844 8.553817 5.702885 5.701862 8.553817 12.767791 8.553817 21.197788l0 137.597845c0 3.966335-2.231831 9.668197-6.694469 17.10661-4.462638 7.437389-9.668197 14.875802-15.618723 22.313192-5.950526 7.437389-12.147668 13.884218-18.594497 19.338441-6.445806 5.454222-11.652388 8.181333-15.618723 8.181333L656.662751 813.972543c-8.428973 0-15.371082-2.850931-20.825304-8.553817-5.455245-5.702885-8.181333-12.520151-8.181333-20.453844L627.656113 609.4341c0-8.428973 2.726088-15.495926 8.181333-21.197788 5.454222-5.702885 12.396331-8.553817 20.825304-8.553817L830.705646 579.682495 830.705646 579.683519zM770.46054 767.113305c1.984191 0 3.843538-1.239224 5.578042-3.718695 1.735527-2.478448 3.347235-5.330402 4.835122-8.553817 1.486864-3.222391 2.603291-6.569626 3.346211-10.04068 0.743944-3.471055 1.115404-6.197142 1.115404-8.181333 0-3.966335-1.486864-7.437389-4.462638-10.413164-2.974751-2.975774-6.445806-4.462638-10.413164-4.462638l-72.890101 0c-3.966335 0-7.437389 1.486864-10.412141 4.462638-2.974751 2.974751-4.463662 6.445806-4.463662 10.413164 0 1.984191 0.372483 4.710278 1.115404 8.181333 0.743944 3.471055 1.859347 6.818289 3.347235 10.04068 1.486864 3.223415 3.098571 6.075369 4.834098 8.553817 1.735527 2.479471 3.594875 3.718695 5.578042 3.718695L770.46054 767.113305 770.46054 767.113305zM785.336342 674.885787c3.966335 0 7.313569-2.106987 10.04068-6.321986s4.091178-8.306176 4.091178-12.272511c0-1.983167-0.372483-4.585435-1.115404-7.80885-0.743944-3.223415-1.735527-6.445806-2.975774-9.66922-1.239224-3.223415-2.726088-5.949502-4.462638-8.181333-1.734504-2.231831-3.594875-3.346211-5.578042-3.346211l-87.765903 0c-1.983167 0-3.842515 1.115404-5.578042 3.346211-1.734504 2.231831-3.346211 4.957919-4.834098 8.181333-1.487887 3.223415-2.604314 6.445806-3.347235 9.66922-0.743944 3.223415-1.115404 5.825682-1.115404 7.80885 0 3.966335 1.487887 8.057513 4.463662 12.272511 2.974751 4.214998 6.445806 6.321986 10.412141 6.321986L785.336342 674.885787 785.336342 674.885787z" fill="#1296db" p-id="8462"></path></svg>
              <span style="margin-left: 6px;">更多信息</span>
            </div>
          </template>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="访客身份证号" prop="idno">
                <el-input v-model="form.idno" placeholder="请输入访客身份证号码"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访客性别" prop="sex">
                <el-select v-model="form.sex" placeholder="请选择性别" style="width: 100%">
                  <el-option
                      v-for="item in sexList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访客工作单位" prop="visitorCompanyName">
                <el-input v-model="form.visitorCompanyName" placeholder="请输入访客工作单位"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车牌号" prop="plateNum">
                <el-input v-model="form.plateNum" placeholder="请输入车牌号码"/>
              </el-form-item>
            </el-col>

            <el-col :span="16">
              <el-form-item label="访问事由" prop="reason">
                <el-input  v-model="form.reason"  placeholder="请输入访问事由"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="form.remark" rows="4" placeholder="备注..."/>
              </el-form-item>

            </el-col>
<!--            <el-col :span="24">
              <el-form-item label="设备列表" prop="deviceList">
                <el-transfer
                    style="text-align: left; display: inline-block"
                    class="audit-device-transfer"
                    v-model="form.deviceList"
                    filterable
                    :left-default-checked="[]"
                    :right-default-checked="[]"
                    :titles="['未选择设备', '已选择设备']"
                    :props="{
                      key: 'id',
                      label: 'name'
                    }"
                    :format="{
                      noChecked: '${total}',
                      hasChecked: '${checked}/${total}'
                    }"
                    :data="deviceList">
                  <div slot-scope="{ option }" :class="option.status === 0 ? 'offline' : 'online'">
                    <div class="option_label">
                      <span>{{ option.name }}</span>
                      <span style="color: #b2b2b2;margin-left: 5px;">({{ option.sn }})</span>
                    </div>
                  </div>
                </el-transfer>
              </el-form-item>
            </el-col>-->
          </el-row>
        </el-card>
      </el-form>
    </div>


    <device-select-dialog ref="deviceSelectDialogRef" @confirm="handleDeviceConfirm"/>
  </el-drawer>
</template>

<script>
import {VisitorApplyApi} from '@/api/server/visitorApply';
import {DmsDeviceApi} from "@/api/server/dmsDevice";
import {VisitorTypeApi} from "@/api/server/visitorType";
import dayjs from "dayjs";
import DeviceSelectDialog from "@/views/visitor/components/device-select-dialog.vue";
export default {
  name: "invite",
  components: {
    DeviceSelectDialog
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
           return time.getTime() <= Date.now() - 8.64e7;
        },
      },
      dialogVisble: false,
      submitLoading: false,
      form: {},
      rules: {
        visitor: [{required: true,message: '访客身份证号不能为空', trigger: 'blur'}],
        phoneNum: [
            {required: true,message: '访客手机号不能为空', trigger: 'blur'},
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('手机号不能为空'));
                } else if (!/^1[3456789]\d{9}$/.test(value)) {
                  callback(new Error('请输入正确的手机号'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
        ],
        visitorTypeId: [{required: true,message: '访客类型不能为空', trigger: 'blur'}],
        // idno: [{required: true,message: '访客身份证号码不能为空', trigger: 'blur'}],
        visitDateTime: [{required: true,message: '访问时间不能为空', trigger: 'blur'}],
        personCnt: [{required: true,message: '随行人数不能为空', trigger: 'blur'}],
        // reason: [{required: true,message: '访问事由不能为空', trigger: 'blur'}],
        deviceList: [{required: true,message: '设备不能为空', trigger: 'blur'}],
      },
      deviceList: [],
      visitorTypeList: [],
      sexList: [
          {
            value: '男',
            label: '男'
          },
          {
            value: '女',
            label: '女'
          }
      ]
    }
  },
  methods: {
    queryVisitorTypeList(){
      VisitorTypeApi.getVisitorTypeList().then(response => {
        this.visitorTypeList = response.data;
      })
    },
    queryDeviceList(){
      const params = {
        allowVisitor: true
      }
      DmsDeviceApi.queryDmsDeviceList(params).then(response => {
        this.deviceList = response.data;
      })
    },
    //关闭抽屉
    handleClose() {
      this.dialogVisble = false;
    },
    //打开对话框
    show() {
      this.dialogVisble = true
      this.$nextTick(() => {
        let startTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
        let endTime = dayjs(new Date().getTime() + 24 * 60 * 60 * 1000).format('YYYY-MM-DD HH:mm:ss');
        this.form = {
          personCnt: 1,
          visitDateTime: [startTime, endTime]
        };
        this.queryVisitorTypeList();
        this.handleChangeVisitDateTime(this.form.visitDateTime);
        this.queryDeviceList();
      })
    },
    handleChangeVisitDateTime(date){
      this.form.visitDate = null;
      this.form.visitEndDate = null;
      if(date){
        this.form.visitDate = date[0];
        this.form.visitEndDate = date[1];
      }
    },
    handleChangeVisitorType(){
      let visitorType = this.visitorTypeList.filter(item => item.id == this.form.visitorTypeId);
      if(visitorType.length > 0){
        this.form.deviceList = visitorType[0]?.deviceList || [];
        this.form.deviceIds = visitorType[0]?.deviceList?.map(d=>d.id) || [];
      }
    },
    handleDeviceConfirm(data){
      // this.form.deviceList = data || [];
      // this.form.deviceIds = data?.map(d=>d.id) || [];
      this.$set(this.form, 'deviceList', data);
      this.$set(this.form, 'deviceIds', data);
    },
    handleDeviceClick(){
      this.$refs.deviceSelectDialogRef.show(this.form.deviceList);
    },
    handleSubmit(){ //提交拒绝审核
      this.$refs.formRef.validate(valid => {
        if(valid){
          this.submitLoading = true;
          VisitorApplyApi.saveApply(this.form).then(response => {
            if(response.code == 200){
              this.$message.success("提交成功");
              this.dialogVisble = false;
              this.$emit('success');
            }else{
              this.$message.error(response.message || '提交失败');
            }
          }).finally(() => {
            this.submitLoading = false;
          })
        }
      })
    },

  }
}
</script>

<style>
::v-deep .el-select {
  width: 140px;
  height: 36px;
  margin-left: 0px;
}
.audit-device-transfer {
  --el-transfer-panel-width: 450px;
  --el-transfer-panel-body-height: 400px;
}
.audit-device-transfer .el-transfer-panel {
  width: 260px !important;
}
.audit-device-transfer .online::after {
  margin-left: 10px;
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  width: 8px;
  height: 8px;
  background: #1ab137;
  border-radius: 50%;
}

.audit-device-transfer .offline::after {
  margin-left: 10px;
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  width: 8px;
  height: 8px;
  background: #ff0000;
  border-radius: 50%;
}
.audit-device-transfer .option_label{
  margin-left: 11px;
}
::v-deep .el-select {
  width: 140px;
  height: 36px;
}
.access{
  width: 100%;
  border: 1px solid #e9eaef;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  height: 28px;
  margin-top: 3px;
  cursor: pointer;
}
.access .wrap{
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
}
.access .wrap_item{
  padding: 5px 0.5rem 0px 0.5rem;
  color: #3172f6;
  background: rgba(64, 158, 255, .12);
  border-radius: 2px;
  margin-right: 8px;
  height: 20px;
  line-height: 1;
  max-width: 88%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.visitor-type-card .el-card__header{
  background: #f6f7fb;
  font-weight: bold;
}
</style>